import PropTypes from 'prop-types';
import React from 'react';
import { BaseComponent } from '../../../components/BaseComponent';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Search, Times } from '../../../components/Icon';
import { changeWorkflowFilter } from '../actions';

import styles from './SearchText.module.css';

const STATE = {
  search: '',
};
/* eslint-disable react/prefer-stateless-function */
class WorkflowSearchTextComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      search: props.filter.searchString || '',
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  doSearch() {
    this.props.setSearchString(this.state.search);
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.search);
    }
  };

  searchStringChangeHandler() {
    this._t = this.timeout(
      () => {
        this.props.setSearchString(this.state.search);
      },
      600,
      this._t,
    );
  }

  render() {
    return (
      <div className="d-flex">
        <input
          type="text"
          className={`form-control fw-light ${styles.Input}`}
          name="search"
          value={this.state.search}
          placeholder={this.lblStr('search')}
          onChange={evt => {
            this.setState({ search: evt.target.value });
          }}
          onKeyPress={this.handleKeyPress}
        />
        <button className={`btn btn-outline-secondary ${styles.Button}`} type="button" onClick={this.doSearch.bind(this)}>
          <Search />
        </button>
      </div>
    );
  }
}

WorkflowSearchTextComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setSearchString(string) {
      dispatch(changeWorkflowFilter('searchString', string));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const WorkflowSearchText = compose(withConnect, withRouter, injectIntl)(WorkflowSearchTextComp);
